export default __webpack_public_path__ + "static/home-bmw-posters-201baefbc8b5bc2f6eb1adab5dfe9241.mp4";